/* eslint-disable no-unused-vars */
export enum EPrescriptionStatus {
  ACTIVE = "ACTIVE",
  EXPIRING_SOON = "EXPIRING_SOON",
  EXPIRED = "EXPIRED",
  NO_REFILLS_REMAINING = "NO_REFILLS_REMAINING",
  DECLINED = "DECLINED",
}

export interface IPrescriptionResponse {
  id: string;
  name: string;
  itemId: string;
  displayStatus: EPrescriptionStatus;
  petId: string;
  petName: string;
  prescribedAt: string;
  expirationDate: string;
  prescribedBy: string;
}
export interface IPrescriptionDetailsResponse {
  id: string;
  name: string;
  itemId: string;
  displayStatus: EPrescriptionStatus;
  petId: string;
  petName: string;
  prescribedAt: string;
  expirationDate: string;
  prescribedBy: string;
  allowedUse: number;
  quantity: number;
  remainingFills: number;
  instructions: string;
  dose: string;
}

export interface IGetPrescriptionsResponse {
  getOnlinePharmacyPrescriptions: {
    prescriptions: IPrescriptionResponse[];
    success: boolean;
    hasMore: boolean;
  };
}

export interface IGetPrescriptionByIdResponse {
  getOnlinePharmacyPrescriptionById: {
    prescription: IPrescriptionDetailsResponse;
  };
}

export interface IMappedPrescription {
  id: string;
  name: string;
  itemId: string;
  status: EPrescriptionStatus;
  petId: string;
  petName: string;
  prescribedAt: string;
  expirationDate: string;
  prescribedBy: string;
}

export interface IMappedPrescriptionDetails {
  id: string;
  name: string;
  itemId: string;
  status: EPrescriptionStatus;
  petId: string;
  petName: string;
  prescribedAt: string;
  expirationDate: string;
  prescribedBy: string;
  allowedUse: number;
  quantity: number;
  remainingFills: number;
  instructions: string;
  dose: string;
}

export interface IGetMedicineUrlResponse {
  getOnlinePharmacyItems: {
    url: string;
  };
}
